/* Common Imports */
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { PhoneOutlined } from "@material-ui/icons";
import React from "react";
import AppConfig from "../../../../AppConfig";
import ContactFormModal from "../../../modals/ContactFormModal";

/* Component Imports */

/* Data Imports */

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    objectFit: "contain",
    borderRadius: "24px",
    border: "1px solid #ffffff",
    background:
      "radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.00) 100%)",
    padding: "0rem 4rem 2rem 4rem ",
    backdropFilter: "blur(21px)",
    margin: "20rem 0rem 0rem 0rem",
    [theme.breakpoints.only("xs")]: {
      padding: "2rem 1rem 2rem 1rem ",
    },
    [theme.breakpoints.only("lg")]: {
      margin: "25rem 0rem 0rem 0rem",
    },
  },
  illustrationSizer: {
    padding: "0rem 0rem 0rem 0rem",
    /* XXS breakpoint */
    // [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
    //   height: "370px",
    //   width: "267px",
    // },
    // [theme.breakpoints.only("xs")]: {
    //   height: "505px",
    //   width: "364px",
    // },
    // [theme.breakpoints.down("sm")]: {
    //   height: "505px",
    //   width: "364px",
    // },
    // [theme.breakpoints.only("md")]: {
    //   height: "555px",
    //   width: "400px",
    // },
    // [theme.breakpoints.only("lg")]: {
    //   height: "555px",
    //   width: "400px",
    // },
    // [theme.breakpoints.only("xl")]: {
    //   height: "793px",
    //   width: "572px",
    // },
    // // /* XXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
    //   height: "1110px",
    //   width: "801px",
    // },
    // // /* XXXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
    //   height: "1388px",
    //   width: "1001px",
    // },
    [theme.breakpoints.only("xs")]: {
      height: "300px",
      width: "295px",
    },
  },
  btnRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "1rem",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row-reverse",
      justifyContent: "center",
      alignItems: "center",
      gap: "1rem",
      margin: " 1rem 0rem 0rem 0rem",
    },
  },
  primaryButton: {
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    background: "#A8626C",
    color: "#FFFFFF",
    // margin: "1.5rem 0rem 0rem 0rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "capitalize",
    borderRadius: "0.75rem",
    width: "100%",
    "&:hover": {
      background: "#A8626C",
      color: "#FFFFFF",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      fontSize: "0.875rem",
      margin: "0.5rem 0rem 0rem 0rem",
    },
  },
  secondaryButton: {
    background: "#FFFFFF",
    color: "#A8626C",
    borderRadius: "0rem",
    border: "solid 1px #A8626C",
    width: "100%",
    "&:hover": {
      background: "#FFFFFF",
      color: "#A8626C",
    },
    padding: "0.5rem 0.5rem 0.5rem 0.5rem",
    fontSize: "1rem",
    fontWeight: "500",
    textTransform: "capitalize",

    borderRadius: "0.75rem",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      margin: "0.5rem 0rem 0rem 0rem",
      fontSize: "0.875rem",
      //   background: "#6934711F",
    },
  },
  buttonText: {
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileButtonText: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));

const HalcyonLogoContainer = () => {
  const classes = useStyles();
  const [showNumber, setShowNumber] = React.useState(false);

  const handleClick = (event) => {
    // For mobile devices (sm and down), directly make the call
    if (window.innerWidth <= 960) {
      // 960px is Material-UI's md breakpoint
      return true; // Allow default href behavior
    }
    // For desktop devices, show the number
    event.preventDefault();
    setShowNumber(true);
  };
  const [openContactForm, setOpenContactForm] = React.useState(false);
  const handleOpenContactForm = () => {
    setOpenContactForm(true);
  };
  const handleCloseContactForm = () => {
    setOpenContactForm(false);
  };
  return (
    <React.Fragment>
      <ContactFormModal
        open={openContactForm}
        onClose={handleCloseContactForm}
        source="Heavie Halcyon"
      />
      <div className={classes.megaContainer}>
        <img
          alt={AppConfig.imageAltText}
          loading="lazy"
          referrerPolicy="no-referrer"
          height={600}
          width={338}
          src="/images/halcyon-logo/halcyongroup.svg"
          className={classes.illustrationSizer}
        />
        <div className={classes.btnRow}>
          {!showNumber ? (
            <Button
              variant="outlined"
              onClick={handleClick}
              href={`tel:08071844962`}
              title="View Number"
              rel="noopener"
              className={classes.primaryButton}
              startIcon={<PhoneOutlined />}
            >
              <span className={classes.buttonText}>View Number</span>
              <span className={classes.mobileButtonText}>Call Now</span>
            </Button>
          ) : (
            <Button
              variant="outlined"
              href={`tel:08071844962`}
              title="Call Now"
              rel="noopener"
              className={classes.primaryButton}
              startIcon={<PhoneOutlined />}
            >
              08071844962
            </Button>
          )}
          <Button
            variant="outlined"
            onClick={handleOpenContactForm}
            title="Get a callback"
            rel="noopener"
            className={classes.secondaryButton}
          >
            Get callback
          </Button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HalcyonLogoContainer;
